<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">CPF / CNPJ</label>
                            <input type="text" id="document" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                v-model="advanced_search_input.document"
                                v-mask="['###.###.###-##', '##.###.###/####-##']">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Nome / Razão Social</label>
                            <input type="text" id="description" class="form-control"
                                placeholder="Ex: José Antônio Silva" v-model="advanced_search_input.name">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Protocolo</label>
                            <input type="text" id="protocol" class="form-control"
                                placeholder="Ex: ########-######-IRPF-###" v-model="advanced_search_input.protocol"
                                v-mask="['##############-IRPF-###']">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Status</label>
                            <select class="form-control" v-model="advanced_search_input.status">
                                <option value="">Todos</option>
                                <option value="Em análise">Em análise</option>
                                <option value="Em execução">Em execução</option>
                                <option value="Aguardando pagamento">Aguardando pagamento</option>
                                <option value="Finalizado">Finalizado</option>
                                <option value="Em auditoria">Em auditoria</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Declarações enviadas
                            <br><small><span v-if="total_itens > 0">Total registros encontrados: {{
                                formatDecimal(total_itens) }}</span></small>
                        </h6> <button class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i>
                            Recarregar dados</button>
                    </div>
                    <div class="card-body" :class="list_declarations.length <= 0 ? 'card-body-no-spaccing' : ''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Protocolo</th>
                                        <th>Documento</th>
                                        <th>Nome</th>
                                        <th>Telefone</th>
                                        <th>Valor</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Data envio</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ir) in list_declarations" :key="ir.id">
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.protocol }} <br>
                                            <span class="badge badge-success" v-if="ir.designation != ''">{{
                                                ir.designation }}</span>
                                            <span class="badge badge-danger" v-else>Não designado</span>
                                        </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.document_formatted }} </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.name }} </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.phone_formatted }} </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.amount_formatted }} </td>
                                        <td class="align-middle text-center"><span class="badge"
                                                :class="badgeStatus(ir.status)">{{ ir.status }}</span></td>
                                        <td class="align-middle text-center">{{ ir.created_at_formatted }} </td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button type="button" class="dropdown-item"
                                                        @click="openDetails(ir)">Detalhes</button>
                                                    <button type="button" class="dropdown-item"
                                                        @click="showModalChangeStatus(ir)">Alterar status</button>
                                                    <button type="button" class="dropdown-item"
                                                        @click="showModalUser(ir)">Designar usuário</button>
                                                    <button type="button" class="dropdown-item"
                                                        @click="showModalReceipt(ir)">Recibo</button>
                                                    <button type="button" class="dropdown-item"
                                                        @click="showModalDeclaration(ir)">Declaração</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="list_declarations.length > 0 && page > 1">
                                        <td colspan="9" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="list_declarations.length <= 0">
                                        <td colspan="9" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="modalDisplayChangeStatus" class="modal" :style="{ display: modalDisplayChangeStatus }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateStatus">
                    <div class="modal-content">
                        <div class="modal-header">
                            Alterar status declaração
                            <button type="button" class="close" @click="closeModalChangeStatus()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Status</label>
                                    <select class="form-control" v-model="ir.status">
                                        <option value="" disabled selected>Escolha um status</option>
                                        <option value="Em análise">Em análise</option>
                                        <option value="Em execução">Em execução</option>
                                        <option value="Aguardando pagamento">Aguardando pagamento</option>
                                        <option value="Finalizado">Finalizado</option>
                                        <option value="Em auditoria">Em auditoria</option>
                                        <option value="Cancelado">Cancelado</option>
                                        <option value="Desistência">Desistência</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalChangeStatus()"><i
                                    class="fa fa-times"></i> Cancelar</button>
                            <button type="submit" class="btn btn-success" :disabled='!validateSpdateStatus'><i
                                    class="fa fa-check"></i> Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayUser" class="modal" :style="{ display: modalDisplayUser }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateDesignation">
                    <div class="modal-content">
                        <div class="modal-header">
                            Designação IR
                            <button type="button" class="close" @click="closeModalUser()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Selecione um usuário</label>
                                    <multiselect v-model="user_multiselect" :options="users_options"
                                        :custom-label="userWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectUser">
                                        <template #noResult>
                                            Nenhum usuário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalUser()"><i
                                    class="fa fa-times"></i> Cancelar</button>
                            <button type="submit" class="btn btn-success" :disabled='!validateUpdateStatusUser'><i
                                    class="fa fa-check"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayReceipt" class="modal" :style="{ display: modalDisplayReceipt }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateReceipt">
                    <div class="modal-content">
                        <div class="modal-header">
                            Recibo IR
                            <button type="button" class="close" @click="closeModalReceipt()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="this.ir.receipt == ''">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <h6>Não há recibo registrado</h6>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="button" class="btn btn-success" @click="downloadRecepit"> Baixar
                                        último
                                        recibo enviado <i class="fa fa-download"></i></button>
                                </div>
                            </div>
                            <hr>
                            <div class="row mt-4">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Atualizar recibo</label><br>
                                    <small>Tamanho máximo: 10MB</small>
                                    <input type="file" multiple @change="handleFileChange" ref="fileInput">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="file.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho arquivo selecionado: {{ file.size }}</small>
                                </div>
                            </div>
                            <div class="row" v-if="files_upload.length > 0">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Descrição</th>
                                                    <th>Tamanho</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(file, index) in files_upload" :key="index">
                                                    <td>{{ file.name }} </td>
                                                    <td>{{ (file.size / (1024 * 1024)).toFixed(2) }} MB </td>
                                                    <td><i class="fa fa-times pointer"
                                                            @click="removeFileList(file)"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-5" v-if="progressBarFile > 0">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <div class="progress">
                                        <div class="progress-bar bg-success" role="progressbar"
                                            :style="'width:' + progressBarFile + '%'" aria-valuenow="25"
                                            aria-valuemin="0" aria-valuemax="100">Progresso</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalReceipt()"><i
                                    class="fa fa-times"></i> Cancelar</button>
                            <button type="submit" class="btn btn-success" :disabled='!isDisabledFileReceipt'><i
                                    class="fa fa-check"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>


    <!--Declaração-->
    <div id="modalDisplayDeclaration" class="modal" :style="{ display: modalDisplayDeclaration }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateDeclaration">
                    <div class="modal-content">
                        <div class="modal-header">
                            Declaração IR
                            <button type="button" class="close" @click="closeModalDeclaration()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="this.ir.declaration == ''">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <h6>Não há declaração registrada</h6>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="button" class="btn btn-success" @click="downloadDeclaration"> Baixar
                                        última
                                        declaração enviada <i class="fa fa-download"></i></button>
                                </div>
                            </div>
                            <hr>
                            <div class="row mt-4">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Atualizar declaração</label><br>
                                    <small>Tamanho máximo: 10MB</small>
                                    <input type="file" multiple @change="handleFileChange" ref="fileInput">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="file.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho arquivo selecionado: {{ file.size }}</small>
                                </div>
                            </div>
                            <div class="row" v-if="files_upload.length > 0">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Descrição</th>
                                                    <th>Tamanho</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(file, index) in files_upload" :key="index">
                                                    <td>{{ file.name }} </td>
                                                    <td>{{ (file.size / (1024 * 1024)).toFixed(2) }} MB </td>
                                                    <td><i class="fa fa-times pointer"
                                                            @click="removeFileList(file)"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-5" v-if="progressBarFile > 0">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <div class="progress">
                                        <div class="progress-bar bg-success" role="progressbar"
                                            :style="'width:' + progressBarFile + '%'" aria-valuenow="25"
                                            aria-valuemin="0" aria-valuemax="100">Progresso</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalDeclaration()"><i
                                    class="fa fa-times"></i> Cancelar</button>
                            <button type="submit" class="btn btn-success" :disabled='!isDisabledFileDeclaration'><i
                                    class="fa fa-check"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import Multiselect from 'vue-multiselect'

export default {
    directives: { mask },
    components: {
        Loading,
        Multiselect
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {status:''},
            list_declarations: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            modalDisplayChangeStatus: 'none',
            modalDisplayUser: 'none',
            modalDisplayReceipt: 'none',
            modalDisplayDeclaration: 'none',
            progressBarFile: 0,
            files_upload: [],
            file: {
                description: '',
                archive: null,
                size: ''
            },
            ir: {
                id: '',
                status: '',
                user: '',
                receipt: '',
                declaration: ''
            },
            users: {},
            users_options: [],
            user_multiselect: '',
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        },
        validateSpdateStatus: function () {
            return this.ir.status != '';
        },
        validateUpdateStatusUser: function () {
            return this.ir.user != '';
        },
        isDisabledFileReceipt: function () {
            return this.files_upload.length > 0;
        },
        isDisabledFileDeclaration: function () {
            return this.files_upload.length > 0;
        },

    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        userWithLang({ value }) {
            return value;
        },
        handleSelectUser(option) {
            this.ir.user = option.key;
            console.log(this.ir);
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.list_declarations = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.list_declarations = {}
            this.advanced_search_input = {}
            this.loadData();
        },
        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/ir', {
                params: {
                    'document': this.advanced_search_input.document,
                    'name': this.advanced_search_input.name,
                    'protocol': this.advanced_search_input.protocol,
                    'status': this.advanced_search_input.status,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.list_declarations = response.data.data;
                    } else {
                        this.list_declarations = this.list_declarations.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        badgeStatus(status) {
            if (status == 'Pendente') {
                return 'badge-info';
            } else if (status == 'Finalizado') {
                return 'badge-success';
            } else if (status == 'Documentos Pendentes') {
                return 'badge-danger';
            }
            return 'badge-info';
        },

        openDetails(ir) {
            this.$router.push({ name: 'ir_detail', params: { id: ir.id } });
        },
        updateStatus(event) {
            event.preventDefault();
            api.put('/ir/' + this.ir.id, { 'data': this.ir, 'type': 'update_status' })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Status declaração atualizada com sucesso!",
                        type: 'success'
                    });
                    this.closeModalChangeStatus();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

        updateDesignation(event) {
            event.preventDefault();
            api.put('/ir/' + this.ir.id, { 'data': this.ir, 'type': 'update_designation' })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Usuário designado atualizado com sucesso!",
                        type: 'success'
                    });
                    this.closeModalUser();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

        handleFileChange(event) {
            if (event.target.files != undefined) {
                const files = event.target.files;
                [...files].forEach(file => {
                    const sizeInBytes = file.size;
                    const sizeInMB = sizeInBytes / (1024 * 1024);
                    if (sizeInMB > 10) {
                        this.$notify({
                            title: "Informação",
                            text: "O arquivo (" + file.name + ") excede o limite de envio. O máximo para envio são 10MB",
                            type: 'info'
                        });
                        this.files_upload = [];
                    } else {
                        this.files_upload.push(file);
                    }
                });

            } else {
                this.file.size = '';
                this.file.archive = null;
            }
            this.$refs.fileInput.value = null;

        },

        removeFileList(file_remove) {
            this.files_upload.forEach((file) => {
                if (file_remove.name == file.name && file_remove.size == file.size && file_remove.type == file.type) {
                    let index = this.files_upload.indexOf(file_remove.name);
                    this.files_upload.splice(index, 1);
                }
            });

            if (this.files_upload.length == 0) {
                this.files_upload = [];
            }
        },

        updateReceipt(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            let total_upload_success = 0;
            let total_upload_error = 0;
            let total_files = this.files_upload.length;
            this.files_upload.forEach((file) => {
                this.progressBarFile = 0;
                const formData = new FormData();
                formData.append('description', file.name);
                formData.append('file', file);
                api.post('/ir/receipt/' + this.ir.id, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: progressEvent => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        this.progressBarFile = percentCompleted;
                    }
                })
                    .then(() => {
                        total_upload_success++;
                    }).catch(error => {
                        total_upload_error++;
                        console.log(error);
                    })
            });

            const interval = setInterval(() => {
                if (total_upload_success + total_upload_error >= total_files) {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Arquivos enviados com sucesso! Foram enviados " + total_upload_success + " com " + total_upload_error + " erros detectados",
                        type: 'success'
                    });
                    this.closeModalReceipt();
                    this.files_upload = [];
                    this.file = {};
                    this.progressBarFile = 0;
                    this.loadData();
                    clearInterval(interval);
                }
            }, 2000);

        },

        updateDeclaration(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            let total_upload_success = 0;
            let total_upload_error = 0;
            let total_files = this.files_upload.length;
            this.files_upload.forEach((file) => {
                this.progressBarFile = 0;
                const formData = new FormData();
                formData.append('description', file.name);
                formData.append('file', file);
                api.post('/ir/declaration/' + this.ir.id, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: progressEvent => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        this.progressBarFile = percentCompleted;
                    }
                })
                    .then(() => {
                        total_upload_success++;
                    }).catch(error => {
                        total_upload_error++;
                        console.log(error);
                    })
            });

            const interval = setInterval(() => {
                if (total_upload_success + total_upload_error >= total_files) {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Arquivos enviados com sucesso! Foram enviados " + total_upload_success + " com " + total_upload_error + " erros detectados",
                        type: 'success'
                    });
                    this.closeModalDeclaration();
                    this.files_upload = [];
                    this.file = {};
                    this.progressBarFile = 0;
                    this.loadData();
                    clearInterval(interval);
                }
            }, 2000);

        },

        generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

        async downloadRecepit() {
            this.isLoading = true;
            api.get('/ir/' + this.ir.id + '/downloadFileReceipt', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    const name_file = this.generateRandom();
                    link.download = name_file;
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewFile();
                    handleRequestErrors(error.status, error);
                })
        },

        async downloadDeclaration() {
            this.isLoading = true;
            api.get('/ir/' + this.ir.id + '/downloadFileDeclaration', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    const name_file = this.generateRandom();
                    link.download = name_file;
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewFile();
                    handleRequestErrors(error.status, error);
                })
        },

        showModalChangeStatus(ir) {
            this.ir.id = ir.id;
            this.modalDisplayChangeStatus = 'block';
        },

        closeModalChangeStatus() {
            this.modalDisplayChangeStatus = 'none';
        },

        showModalUser(ir) {
            this.ir.id = ir.id;
            this.modalDisplayUser = 'block';
        },

        closeModalUser() {
            this.modalDisplayUser = 'none';
        },

        showModalReceipt(ir) {
            this.files_upload = [];
            this.ir.id = ir.id;
            this.ir.receipt = ir.receipt;
            this.modalDisplayReceipt = 'block';
        },

        closeModalReceipt() {
            this.modalDisplayReceipt = 'none';
        },

        showModalDeclaration(ir) {
            this.files_upload = [];
            this.ir.id = ir.id;
            this.ir.declaration = ir.declaration;
            this.modalDisplayDeclaration = 'block';
        },

        closeModalDeclaration() {
            this.modalDisplayDeclaration = 'none';
        },
        async getUsers() {
            this.isLoading = true;
            const response = api.get('/userListAll', { params: { 'no_client': true } })
                .then((response) => {
                    this.users = response.data.users;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
    },
    mounted() {
        this.isLoading = false;
        const response_uses = this.getUsers();
        response_uses.then(() => {
            this.users_options = this.users.map(item => ({
                key: item.name,
                value: item.name + ' / ' + item.role,
            }));

            this.users_mentions = this.users.map(item => ({
                id: item.id,
                name: item.name
            }));

        });
        this.loadData();
    },
}
</script>

<style></style>